export const PRODUCT_CATEGORIES_FEATURE_KEY = 'productCategories';
